<template>
  <div class="message-record-send">
    <tableBox
        :tableData="tableData"
        :tableHead="tableHead"
        :total="total"
        :size="pageSize"
        @pageHandler="pageOperate"></tableBox>
  </div>
</template>

<script>
  import tableBox from '@/components/table/table'
  export default {
    name: 'message-record-send',
    components: {
      tableBox
    },
    data() {
      return {
        tableData: [],
        tableHead: [
          {
            label: '发送时间',
            value: 'sendTime',
            operate: false
          }, {
            label: '手机号',
            value: 'phone',
            operate: false,
          }, {
            label: '短信内容',
            value: 'content',
            operate: false
          }, {
            label: '状态',
            value: 'status',
            type:'status',
            width:'160',
            operate: false,
          }
        ],
        total: 0,
        currentPage: 1,
        pageSize: 10
      }
    },
    created() {
      this.getSendRecord()
    },
    mounted() {

    },
    methods: {
      /**
       *  分页操作
       * @param val
       */
      pageOperate(val) {
        if (val.type == 'currentChange') {
          this.currentPage = val.val
        } else if (val.type == "sizeChange") {
          this.pageSize = val.val
        }
        this.getSendRecord()
      },
      getSendRecord() {
        let postData = {
          pageNum: this.currentPage,
          pageSize: this.pageSize
        }
        this.$http.msgSendRecordAPI(postData).then(res => {
          if (res.status == 1) {
            if (res.data.list.length > 0) {
              res.data.list.map( item   => {
                if (item.status == 0) {
                  item.status = 1
                } else if (item.status == 1) {
                  item.status = 0
                }
              })
            }
            this.tableData = res.data.list
            this.total = res.data.total
          }
        })
      }
    }
  }
</script>

<style lang="scss">

</style>
